<template>
	<div class="col-12 col-md-8">
		<h2>Newsletter</h2>
		<!-- Begin Mailchimp Signup Form -->
		<form action="https://cherrytree.us19.list-manage.com/subscribe/post?u=63cf3e09b5c0a7aac32e73c1a&amp;id=b7c32e6646" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
			<div class="mc-field-group hidden-field" aria-hidden="true">
				<label for="mce-EMAIL">Email Address</label>
				<input type="email" :value="email" name="EMAIL" class="required email" id="mce-EMAIL">
			</div>
			<div id="mce-responses" class="clear">
				<div class="response" id="mce-error-response" style="display:none"></div>
				<div class="response" id="mce-success-response" style="display:none"></div>
			</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
			<div style="position: absolute; left: -5000px;" aria-hidden="true">
				<input type="text" name="b_63cf3e09b5c0a7aac32e73c1a_b7c32e6646" tabindex="-1" value="">
			</div>
			<div class="row justify-content-center">
				<input type="submit" value="Resubscribe" name="subscribe" id="mc-embedded-subscribe" class="btn btn-primary">
			</div>
		</form>
	</div>
</template>

<script>

import { fetchUserDetails } from "@/network/userRequests";

export default {
	name: 'Resubscribe',
	components: {
	},
	data(){
		return {
			email: ""
		}
	},
	created() {
		this.getData()
	},
	methods: {
		getData(){
			fetchUserDetails(userDetails => {
				this.email = userDetails.member_details.email
			});
		}
	}
}
</script>

<style lang="scss" scoped>
	.hidden-field{
		display: none;
	}
</style>
